var _path, _path2, _path3, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIranFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "iran-flag-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 630,
    height: 360,
    viewBox: "0 0 630 360",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M0,0H630V360H0Z",
    fill: "#da0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M0,0H630V240H0Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M0,0H630V120H0Z",
    fill: "#239f40"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(7.8 102.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M0,1.4H36.4M1.4,14V7H12.6v5.6H23.8V7h-7M5.6,12.6H8.4m28,0h-7V7H40.6m0-7V12.6H51.8V0M46.2,0V12.6",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0,19.6H25.2m2.8,0H53.2",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 5.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M0,1.4H36.4M1.4,14V7H12.6v5.6H23.8V7h-7M5.6,12.6H8.4m28,0h-7V7H40.6m0-7V12.6H51.8V0M46.2,0V12.6",
    transform: "translate(0 139.244)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "d",
    transform: "translate(56)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b-2",
    "data-name": "b",
    d: "M0,1.4H36.4M1.4,14V7H12.6v5.6H23.8V7h-7M5.6,12.6H8.4m28,0h-7V7H40.6m0-7V12.6H51.8V0M46.2,0V12.6",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "a-2",
    "data-name": "a",
    d: "M0,19.6H25.2m2.8,0H53.2",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 5.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M0,1.4H36.4M1.4,14V7H12.6v5.6H23.8V7h-7M5.6,12.6H8.4m28,0h-7V7H40.6m0-7V12.6H51.8V0M46.2,0V12.6",
    transform: "translate(0 139.244)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b-3",
    "data-name": "b",
    d: "M0,1.4H36.4M1.4,14V7H12.6v5.6H23.8V7h-7M5.6,12.6H8.4m28,0h-7V7H40.6m0-7V12.6H51.8V0M46.2,0V12.6",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "a-3",
    "data-name": "a",
    d: "M0,19.6H25.2m2.8,0H53.2",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 5.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M0,1.4H36.4M1.4,14V7H12.6v5.6H23.8V7h-7M5.6,12.6H8.4m28,0h-7V7H40.6m0-7V12.6H51.8V0M46.2,0V12.6",
    transform: "translate(0 139.244)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(112)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b-4",
    "data-name": "b",
    d: "M0,1.4H36.4M1.4,14V7H12.6v5.6H23.8V7h-7M5.6,12.6H8.4m28,0h-7V7H40.6m0-7V12.6H51.8V0M46.2,0V12.6",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "a-4",
    "data-name": "a",
    d: "M0,19.6H25.2m2.8,0H53.2",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 5.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M0,1.4H36.4M1.4,14V7H12.6v5.6H23.8V7h-7M5.6,12.6H8.4m28,0h-7V7H40.6m0-7V12.6H51.8V0M46.2,0V12.6",
    transform: "translate(0 139.244)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2.8
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(224)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b-5",
    "data-name": "b",
    d: "M0,1.4H36.4M1.4,14V7H12.6v5.6H23.8V7h-7M5.6,12.6H8.4m28,0h-7V7H40.6m0-7V12.6H51.8V0M46.2,0V12.6",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "a-5",
    "data-name": "a",
    d: "M0,19.6H25.2m2.8,0H53.2",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 5.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M0,1.4H36.4M1.4,14V7H12.6v5.6H23.8V7h-7M5.6,12.6H8.4m28,0h-7V7H40.6m0-7V12.6H51.8V0M46.2,0V12.6",
    transform: "translate(0 139.244)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b-6",
    "data-name": "b",
    d: "M0,1.4H36.4M1.4,14V7H12.6v5.6H23.8V7h-7M5.6,12.6H8.4m28,0h-7V7H40.6m0-7V12.6H51.8V0M46.2,0V12.6",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "a-6",
    "data-name": "a",
    d: "M0,19.6H25.2m2.8,0H53.2",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 5.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M0,1.4H36.4M1.4,14V7H12.6v5.6H23.8V7h-7M5.6,12.6H8.4m28,0h-7V7H40.6m0-7V12.6H51.8V0M46.2,0V12.6",
    transform: "translate(0 139.244)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(112)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b-7",
    "data-name": "b",
    d: "M0,1.4H36.4M1.4,14V7H12.6v5.6H23.8V7h-7M5.6,12.6H8.4m28,0h-7V7H40.6m0-7V12.6H51.8V0M46.2,0V12.6",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "a-7",
    "data-name": "a",
    d: "M0,19.6H25.2m2.8,0H53.2",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 5.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M0,1.4H36.4M1.4,14V7H12.6v5.6H23.8V7h-7M5.6,12.6H8.4m28,0h-7V7H40.6m0-7V12.6H51.8V0M46.2,0V12.6",
    transform: "translate(0 139.244)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2.8
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(392)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c-2",
    "data-name": "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b-8",
    "data-name": "b",
    d: "M0,1.4H36.4M1.4,14V7H12.6v5.6H23.8V7h-7M5.6,12.6H8.4m28,0h-7V7H40.6m0-7V12.6H51.8V0M46.2,0V12.6",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "a-8",
    "data-name": "a",
    d: "M0,19.6H25.2m2.8,0H53.2",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 5.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M0,1.4H36.4M1.4,14V7H12.6v5.6H23.8V7h-7M5.6,12.6H8.4m28,0h-7V7H40.6m0-7V12.6H51.8V0M46.2,0V12.6",
    transform: "translate(0 139.244)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "d-2",
    "data-name": "d",
    transform: "translate(56)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b-9",
    "data-name": "b",
    d: "M0,1.4H36.4M1.4,14V7H12.6v5.6H23.8V7h-7M5.6,12.6H8.4m28,0h-7V7H40.6m0-7V12.6H51.8V0M46.2,0V12.6",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "a-9",
    "data-name": "a",
    d: "M0,19.6H25.2m2.8,0H53.2",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 5.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M0,1.4H36.4M1.4,14V7H12.6v5.6H23.8V7h-7M5.6,12.6H8.4m28,0h-7V7H40.6m0-7V12.6H51.8V0M46.2,0V12.6",
    transform: "translate(0 139.244)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b-10",
    "data-name": "b",
    d: "M0,1.4H36.4M1.4,14V7H12.6v5.6H23.8V7h-7M5.6,12.6H8.4m28,0h-7V7H40.6m0-7V12.6H51.8V0M46.2,0V12.6",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "a-10",
    "data-name": "a",
    d: "M0,19.6H25.2m2.8,0H53.2",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 5.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M0,1.4H36.4M1.4,14V7H12.6v5.6H23.8V7h-7M5.6,12.6H8.4m28,0h-7V7H40.6m0-7V12.6H51.8V0M46.2,0V12.6",
    transform: "translate(0 139.244)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(112)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b-11",
    "data-name": "b",
    d: "M0,1.4H36.4M1.4,14V7H12.6v5.6H23.8V7h-7M5.6,12.6H8.4m28,0h-7V7H40.6m0-7V12.6H51.8V0M46.2,0V12.6",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "a-11",
    "data-name": "a",
    d: "M0,19.6H25.2m2.8,0H53.2",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 5.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M0,1.4H36.4M1.4,14V7H12.6v5.6H23.8V7h-7M5.6,12.6H8.4m28,0h-7V7H40.6m0-7V12.6H51.8V0M46.2,0V12.6",
    transform: "translate(0 139.244)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2.8
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(315 180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M-24.66,37.62A41.04,41.04,0,0,0,23.753,18.709a41.04,41.04,0,0,0-8.948-51.2,45,45,0,0,1,1.906,47.235A45,45,0,0,1-24.66,37.62",
    fill: "#da0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M27.81,29.745A34.38,34.38,0,0,0,18.99-33.3a45,45,0,0,1,8.82,63.045M0,45-2.25,0,0-35.415A13.95,13.95,0,0,0,5.31-30.96V-4.5L3.51,40.185ZM-.9-38.25,0-37.4a6.48,6.48,0,0,0,8.487,2.1A6.48,6.48,0,0,0,11.34-43.56a6.12,6.12,0,0,1-4.992,4.94,6.12,6.12,0,0,1-6.348-3",
    fill: "#da0000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M-24.66-37.62A41.04,41.04,0,0,1,23.753-18.709a41.04,41.04,0,0,1-8.948,51.2,45,45,0,0,0,1.906-47.235A45,45,0,0,0-24.66-37.62",
    fill: "#da0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M27.81-29.745A34.38,34.38,0,0,1,44.579,4.74,34.38,34.38,0,0,1,18.99,33.3a45,45,0,0,0,8.82-63.045M0-45-2.25,0,0,35.415A13.95,13.95,0,0,1,5.31,30.96V4.5L3.51-40.185ZM-.9,38.25,0,37.4A6.48,6.48,0,0,1,11.34,43.56,6.12,6.12,0,0,0,0,41.625",
    fill: "#da0000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIranFlag);
export default __webpack_public_path__ + "static/media/iran-flag.e76d4f59e10b857a7a65008317e9408f.svg";
export { ForwardRef as ReactComponent };